var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export const buildDlqIgnoreRuleCols = () => [
    { accessor: 'id', header: 'Id' },
    { accessor: 'description', header: 'Description' },
    { accessor: 'ignoreRules', header: 'ignoreRules' },
    { accessor: 'env', header: 'env' },
    { accessor: 'region', header: 'region' },
    { accessor: 'dlqName', header: 'dlqName' },
    { accessor: 'logsMustExistPatterns', header: 'logsMustExistPatterns' },
];
export const toIgnoreRuleRawRecord = (_a) => {
    var { ignoreRules, logsMustExistPatterns } = _a, props = __rest(_a, ["ignoreRules", "logsMustExistPatterns"]);
    return (Object.assign(Object.assign({}, props), { ignoreRules: JSON.stringify(ignoreRules), logsMustExistPatterns: logsMustExistPatterns ? JSON.stringify(logsMustExistPatterns) : undefined }));
};
//# sourceMappingURL=util.js.map